var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BrToolBar',{attrs:{"configFilter":_vm.configFilter,"labelTextField":_vm.labelTextField,"addlFilter":_vm.addlFilter,"itemsSelect":_vm.itemsSelect},on:{"search":_vm.buscar}},[_c('BrModalCadastro')],1)}
var staticRenderFns = []

export { render, staticRenderFns }